export default "/_next/static/chunks/fonts/lato-700-8f28e0e1fdb195149f1c30f84d951b61.woff2";